export default (props, vars) => !!props?.['defaultExpanded'];
